export const API_ADMIN = import.meta.env.VITE_ADM_API_URL ?? '';

export class ErroRespostaHttp extends Error {
    readonly status: number;
    readonly retryAfter: string | null;
    /** Corpo JSON do erro (`{codigo, mensagem, ...}`), quando o servidor mandou um. */
    readonly corpo: Record<string, unknown> | null;

    constructor(status: number, retryAfter: string | null = null, corpo: Record<string, unknown> | null = null) {
        super(`Resposta HTTP ${status}`);
        this.status = status;
        this.retryAfter = retryAfter;
        this.corpo = corpo;
    }
}

interface OpcoesRequisicao extends RequestInit {
    csrfToken?: string;
}

export async function requisitarJson<T>(
    caminho: string,
    { csrfToken, headers, ...opcoes }: OpcoesRequisicao = {},
): Promise<T> {
    let resposta: Response;

    try {
        resposta = await fetch(`${API_ADMIN}${caminho}`, {
            ...opcoes,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                ...headers,
                ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
            },
        });
    } catch {
        throw new Error('Falha de rede');
    }

    if (!resposta.ok) {
        let corpo: Record<string, unknown> | null = null;
        try {
            corpo = (await resposta.json()) as Record<string, unknown>;
        } catch {
            corpo = null;
        }
        throw new ErroRespostaHttp(resposta.status, resposta.headers.get('Retry-After'), corpo);
    }
    if (resposta.status === 204) return undefined as T;

    try {
        return (await resposta.json()) as T;
    } catch {
        throw new Error('Resposta invalida');
    }
}
